import { render, staticRenderFns } from "./SuratPeriksaMata.vue?vue&type=template&id=67c6e968&"
import script from "./SuratPeriksaMata.vue?vue&type=script&lang=js&"
export * from "./SuratPeriksaMata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports